import styled from 'styled-components';
import {Button, Modal, Space} from 'antd';

export const StyledTermsAcceptanceModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 8px;
  }
  p {
    margin: 0;
    color: var(--sub-text-color, #5b6b79);
  }
`;

export const StyledTermsAcceptanceModalSpace = styled(Space)`
  width: 100%;
`;

export const StyledTermsAcceptanceModalSection = styled.div`
  .ant-checkbox-wrapper {
    align-items: flex-start;
  }
  a {
    text-decoration: underline;
  }
`;

export const StyledTermsAcceptanceModalButton = styled(Button)`
  width: 100%;
`;
